$(document).ready(function() {
  
//*****************
//   UTILS 
//*****************
  
  $(window).resize(function () {
    $('section.content').css('padding-bottom', $('footer').height());
  });            

  $('section.content').css('padding-bottom', $('footer').height());

   
  $('.search_button').click(function(){
      $(this).closest('form').submit();
//     	$('#search-input').toggleClass('open');
  });  
  
  
//*****************
//   PRODUCT PAGE 
//*****************
  
    $.fn.enableLightBox = function(options) {
        $("a.fancybox").fancybox({
                prevEffect	: 'none',
                nextEffect	: 'none',
                helpers         :{
                                overlay         : 'false'
                            },
                margin: options.margin,
                padding: options.padding,
                autoScale: options.scalePopup
        });

        $(".product_images li a").click(
                function(event){
                    event.preventDefault();
                    //This changes the image in the smaller images (thumbs and large)
                    $('.product_images li.selected').removeClass('selected');
                    $(this).closest('li').addClass('selected');   

                    //when the page loaded I saved the url to the image in the href
                    $('img.primary_image').prop('src', $(this).prop('href'));         
                    $('a.fancybox').prop('href', $(this).prop('href'));

           });
    };
    
    $('#add_to_bag_button').hover(function() {
        $(this).find('i').removeClass('icon-shopping-cart');
        $(this).find('i').addClass('icon-plus');       
    }, function() {
        $(this).find('i').removeClass('icon-plus');
        $(this).find('i').addClass('icon-shopping-cart');               
    }
    );
    
    $('#add_to_bag_button').click(function(evt){
        $(this).parent().submit();

    });  
  
 
  
  
//*****************
//   TOP NAV 
//*****************  
    $("#search-input").focus(searchHasFocus);
    $("#search-input").blur(lostFocus);
    $("#glass_button").click(function(){
        $("#search-form").submit();
    });

    function searchHasFocus(){
       $(".left_search input").animate({"border-top-color": "#666666", "border-bottom-color": "#666666", "border-right-color": "#666666", "border-left-color": "#666666"}, "slow");
        $("#glass_button").animate({"border-top-color": "#666666", "border-bottom-color": "#666666", "border-right-color": "#666666", "border-left-color": "#666666"}, "slow");
    }
    
    function lostFocus(){
         $(".left_search input").animate({"border-top-color": "#CCCCCC", "border-bottom-color": "#CCCCCC", "border-right-color": "#CCCCCC", "border-left-color": "#CCCCCC"}, "slow");
        $("#glass_button").animate({"border-top-color": "#CCCCCC", "border-bottom-color": "#CCCCCC", "border-right-color": "#CCCCCC", "border-left-color": "#CCCCCC"}, "slow");
    }
 
//*****************
//   SIMPLE GRID
//*****************    
	(function ($) {
  		var imageW = 320;
        var imageH = 480;
        var fitImagestoContainers = false;
        var descriptionOnRollover = true;
        var firstLoad = true;
    
    
//        var containerClass;
        var imageContainerWidth;
        var imageContainerHeight;
		
        adjustContainers();

        $(window).resize(function () {
         adjustContainers();
         $('.image_container_large .product_img').removeAttr('style');
         $('.image_container_large .product_img').css('visibility', 'visible');
         $('.image_container_large .product_img').each(function(){
           	adjustImageSize($(this), imageContainerHeight);
         });
       });    
       

       function adjustContainers() {    
         
         imageContainerWidth = $('.image_container_large').width();
         imageContainerHeight = ( imageH / imageW) * imageContainerWidth;
         
         var productInfoContainerH = $('.product_info').height();
         
         $('.image_container_large').css('height', imageContainerHeight + 'px');
         $('.product_container').css('min-height', imageContainerHeight + productInfoContainerH + 'px');

         $('.image_container_large img').removeAttr('style');  

          if(firstLoad) {
              loadImages();
              firstLoad = false;   
           } else {
             adjustImageSize($(this), imageContainerHeight);
           }
         
       };
       
       function loadImages(){
            $('.image_container_large').each(function(){
              var image_container = $(this);
              if(image_container.hasClass('loading')) {                     
                var main_image = image_container.children('.product_img');
                main_image.attr('src', main_image.attr('id'));

                main_image.load(function(){

                  adjustImageSize($(this), imageContainerHeight); 

                  if (descriptionOnRollover)
                    image_container.hover(showProductDetails, hideProductDetails);
                 

                  image_container.removeClass('loading');

                  var duration = Math.floor(Math.random()*1000);
                  main_image.css('visibility','visible').hide().fadeIn(duration);
                  image_container.siblings('.product_info').css('visibility','visible').hide().fadeIn(duration);
                  image_container.parent().css('visibility','visible').hide().fadeIn(duration);
                  
                });
              }
            });           
       }

       function adjustImageSize(image, containerHeight) {
           var imageHeight = $(image).height();
           var imageWidth = $(image).width();
           if(fitImagestoContainers) {
             if(imageHeight > containerHeight) {
               var newW = (imageWidth / imageHeight) * containerHeight;
               $(image).css('width', newW + 'px');
             } 
           } else {
             if(imageHeight < containerHeight) {
                $(image).css('height', containerHeight + 'px');

                $(image).css('width', 'auto');
                var newW = $(image).width();
                //the following is thrown off if padding is added to .product_img
                //although padding might be needed for .product_img when fit_to_containers is true               
                $(image).css('left', ((newW - imageContainerWidth) / 2) * -1 + 'px');
//                $(image).css('left', ($('.product_container').width() - newW) + 'px');

              } else {
                $(image).addClass('height_greater');
                $(image).css('top', ((imageHeight - containerHeight) / 2) * -1 + 'px');
              }             
             
             
           }

       }
     
       
	})(jQuery);
    
        function showProductDetails(){
          $(this).children(".product_popup_info").stop().fadeIn(400);
          $(this).find('img').addClass('imageFade');
        }

        function hideProductDetails(){
          $(this).children(".product_popup_info").stop().fadeOut(300);
          $(this).find('img').removeClass('imageFade');
        }       
  
//*****************
//   MENU
//*****************  
  
  $('.nav_button').click(function(){
        $(this).find('ul').toggle();
    });  
  
  
});

//*****************
//   MENU
//*****************  

$(window).load(function() {
        var menuOffset = $('.menu').offset().top;
        var winHeight = $(window).height();
        var contentHeight = $('.holder').height();
        var goMobileAt = $('.mobile_data').width();
        var menuFixedH = 50;
        var menuFixedPadding = 20;
        
        console.log('mobile width: ' + goMobileAt);
        if(contentHeight > (winHeight + 200)){
            if($(window).width() > goMobileAt)
                setMenuStyle();

            $(window).scroll(function(){
              if($(window).width() > goMobileAt)
                setMenuStyle();
            });
        }
        $(window).resize(function(){
           if($(window).width() < goMobileAt && $('.main_banner, div.main_cart, li.main_cart, .menu').hasClass('fixed'))
                $('.main_banner, div.main_cart, li.main_cart, .menu').removeClass('fixed');
        });
        function setMenuStyle() {

//           if($(window).scrollTop() > menuOffset) {
//                 $('.main_banner, div.main_cart, li.main_cart, .menu').addClass('fixed');
//                 menuFixedH = $('.menu.fixed').height();
//                 menuFixedPadding = parseInt($('.menu.fixed').css('padding-top')) * 2;
//                 $('section.content').css('padding-top', menuOffset - menuFixedH - menuFixedPadding);

//            } else if ($(window).scrollTop() < menuOffset - menuFixedH - menuFixedPadding) {
//                 $('.main_banner, div.main_cart, li.main_cart, .menu').removeClass('fixed');
//                 $('section.content').css('padding-top', 0);
//            }
        }
});	



function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

String.prototype.startsWith = function(str) {
    return ( str === this.substr( 0, str.length ) );
};
document.addEventListener("DOMContentLoaded", () => {
  const quickViewBtns = document.querySelectorAll(".quick-view-btn");
  const quickViewPopup = document.getElementById("quick-view-popup");
  const overlay = document.querySelector(".quick-view-overlay");
  const closeBtn = document.querySelector(".close-quick-view");

  quickViewBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const productData = JSON.parse(btn.getAttribute("data-product"));
      showQuickView(productData);
    });
  });

  const showQuickView = (product) => {
    document.getElementById("quick-view-product-image").src =
      product.featured_image.src;
    document.getElementById("quick-view-product-title").textContent =
      product.title;
    document.getElementById("quick-view-product-price").textContent =
      Shopify.formatMoney(product.price);
    document.getElementById("quick-view-product-description").textContent =
      product.description || "No description available.";
    document
      .getElementById("quick-view-product-link")
      .setAttribute("href", product.url);

    quickViewPopup.classList.remove("hidden");
    quickViewPopup.style.opacity = "1";
    quickViewPopup.style.visibility = "visible";
  };

  const closeQuickView = () => {
    quickViewPopup.style.opacity = "0";
    quickViewPopup.style.visibility = "hidden";
    quickViewPopup.classList.add("hidden");
  };

  closeBtn.addEventListener("click", closeQuickView);
  overlay.addEventListener("click", closeQuickView);
});
